import * as ActionTypes from 'automation-ui-action-features/constants/ActionTypes';
import { ENROLLMENT } from 'automation-ui-flow-core/canvas/SpecialActionIds';
import { EnrollmentStates, ExecutionStates, LogEventTypes, NotificationTypes } from 'automation-ui-log-events/constants/LogEventConstants';
import { getFollowedBranchIndex, getIdempotencyId, getTimestamp } from 'automation-ui-log-events/records/LogEvent/utils';
import { Map as ImmutableMap } from 'immutable';
export const getExecutionContextMap = logEvents => {
  let executionContextMap = ImmutableMap();
  // This logic will be updated to handle all the different types of log events
  logEvents.forEach(logEvent => {
    const hasSupportedStatus = logEvent.notificationType === NotificationTypes.SUCCESS || logEvent.notificationType === NotificationTypes.ERROR || logEvent.executionState === ExecutionStates.ASYNC;
    if (!hasSupportedStatus) {
      return;
    }
    const logEventKey = getIdempotencyId(logEvent);
    const timestamp = getTimestamp(logEvent);
    if (logEvent.type === LogEventTypes.ACTION_EXECUTION && logEvent.action.actionId) {
      var _executionContextMap$;
      if (((_executionContextMap$ = executionContextMap.get(logEvent.action.actionId)) === null || _executionContextMap$ === void 0 ? void 0 : _executionContextMap$.timestamp) > timestamp) {
        return;
      }
      executionContextMap = executionContextMap.set(logEvent.action.actionId, {
        actionId: logEvent.action.actionId,
        status: logEvent.executionState === ExecutionStates.SUCCESS ? 'success' : logEvent.executionState === ExecutionStates.ASYNC ? 'selected' : 'danger',
        logEventKey,
        timestamp
      });
    } else if (logEvent.type === LogEventTypes.ENROLLMENT) {
      executionContextMap = executionContextMap.set(ENROLLMENT, {
        actionId: ENROLLMENT,
        status: logEvent.enrollmentState === EnrollmentStates.ENROLLED ? 'success' : 'danger',
        logEventKey,
        timestamp
      });
    } else if (logEvent.type === LogEventTypes.UNENROLLMENT) {
      executionContextMap = executionContextMap.set('unenrollment', {
        actionId: 'unenrollment',
        status: logEvent.enrollmentState === EnrollmentStates.COMPLETED ? 'success' : 'danger',
        logEventKey,
        timestamp
      });
    }
  });
  return executionContextMap;
};
export const getFollowedBranchIndexForAction = (branchActionId, logEvents) => {
  const currentActionLogEvent = logEvents.find(logEvent => logEvent.type === LogEventTypes.ACTION_EXECUTION && logEvent.action.actionId === branchActionId);
  if (!currentActionLogEvent) {
    return null;
  }
  return getFollowedBranchIndex(currentActionLogEvent);
};
export const isBranchAction = (actionId, logEvents) => {
  const branchActionTypes = new Set([ActionTypes.LIST_BRANCH, ActionTypes.STATIC_BRANCH, ActionTypes.AB_TEST_BRANCH]);
  const currentActionLogEvent = logEvents.find(logEvent => logEvent.type === LogEventTypes.ACTION_EXECUTION && logEvent.action.actionId === actionId);
  return branchActionTypes.has(currentActionLogEvent === null || currentActionLogEvent === void 0 ? void 0 : currentActionLogEvent.action.actionType);
};

/*
 Note: This function is used to determine if the workflow has been updated in the current execution.
 We decided to hide the workflow even if the modification did not change the shape of the workflow.
*/
export const isWorkflowUpdatedInCurrentExecution = (flow, executionContextMap) => {
  var _flow$updateMetadata$, _flow$updateMetadata, _executionContextMap$2, _executionContextMap$3;
  const flowLastUpdated = (_flow$updateMetadata$ = flow === null || flow === void 0 || (_flow$updateMetadata = flow.updateMetadata) === null || _flow$updateMetadata === void 0 ? void 0 : _flow$updateMetadata.updatedAt) !== null && _flow$updateMetadata$ !== void 0 ? _flow$updateMetadata$ : 0;
  const enrollmentStartTime = (_executionContextMap$2 = executionContextMap.get('enrollment')) === null || _executionContextMap$2 === void 0 ? void 0 : _executionContextMap$2.timestamp;
  const enrollmentEndTime = (_executionContextMap$3 = executionContextMap.get('unenrollment')) === null || _executionContextMap$3 === void 0 ? void 0 : _executionContextMap$3.timestamp;
  return flowLastUpdated > enrollmentStartTime && flowLastUpdated < enrollmentEndTime;
};